import React from 'react';

// Le forme di pagamento della vendita in struttura, con le etichette che legge
// l'operatore. L'omaggio è una forma di pagamento a sé: la struttura regala il
// prodotto, l'acquisto vale come pagato a zero e non produce documento fiscale.
export const OMAGGIO = 'FREE';

export const FORME_PAGAMENTO = [
    { value: "CASH", label: "Contanti" },
    { value: "CARD", label: "Carta di credito" },
    { value: "BANK_TRANSFER", label: "Bonifico bancario" },
    { value: OMAGGIO, label: "Omaggio" },
];

/**
 * L'etichetta di una forma di pagamento già registrata: serve dove l'ordine si
 * legge e basta (dettaglio, elenchi), che è anche l'unico posto dove può
 * comparire l'omaggio. Se arriva un valore che non conosciamo lo si mostra
 * com'è, invece di lasciare il campo vuoto.
 */
export const etichettaPagamento = (valore) =>
    FORME_PAGAMENTO.find(forma => forma.value === valore)?.label || valore || '';

/**
 * Le forme di pagamento di un acquisto (anche quelli fatti dal player), con le etichette delle forme
 * che la struttura offre: in struttura, Stripe, bonifico (più l'omaggio). Contanti e carta sono
 * pagamenti in struttura registrati dall'operatore.
 */
const FORME_ACQUISTO = {
    CLUB: 'In struttura',
    CASH: 'In struttura · contanti',
    CARD: 'In struttura · carta',
    STRIPE: 'Stripe',
    BANK_TRANSFER: 'Bonifico',
    [OMAGGIO]: 'Omaggio',
};
export const etichettaFormaAcquisto = (valore) => FORME_ACQUISTO[valore] || etichettaPagamento(valore);

/** Forma di pagamento e, accanto, Pagato / Non pagato (mai «In attesa»). */
export const PagamentoAcquisto = ({ forma, pagato }) => (
    <>
        {etichettaFormaAcquisto(forma) || '—'}
        {pagato === true && <span className="sid-chip-pagato ms-2">Pagato</span>}
        {pagato === false && <span className="sid-chip-attesa ms-2">Non pagato</span>}
    </>
);
